import { MadSDKAPIError } from "../../errors/base";
export class AdvertisersFetchFailed extends MadSDKAPIError {
    constructor(originalError) {
        super(originalError);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, AdvertisersFetchFailed);
        }
        this.name = "AdvertisersFetchFailed";
        this.message = "Failed to retrieve advertisers. Please try again at a later time.";
    }
}
export class AdvertiserCreationFailed extends MadSDKAPIError {
    constructor(originalError) {
        super(originalError);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, AdvertiserCreationFailed);
        }
        this.name = "AdvertiserCreationFailed";
        this.message = "Failed to create advertiser. Please try again at a later time.";
    }
}
export class AdvertiserCreationFailedHost extends MadSDKAPIError {
    constructor(originalError) {
        super(originalError);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, AdvertiserCreationFailedHost);
        }
        this.name = "AdvertiserCreationFailedHost";
        this.message = "Failed to create advertiser. The Advertiser Domain is invalid.";
    }
}
export class AdvertiserCreationFailedIdExists extends MadSDKAPIError {
    constructor(originalError) {
        super(originalError);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, AdvertiserCreationFailedIdExists);
        }
        this.name = "AdvertiserCreationFailedIdExists";
        this.message =
            "Failed to create advertiser. An advertiser with this External ID already exists.";
    }
}
export class AdvertiserUpdateFailed extends MadSDKAPIError {
    constructor(originalError) {
        super(originalError);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, AdvertiserUpdateFailed);
        }
        this.name = "AdvertiserUpdateFailed";
        this.message = "Failed to update advertiser. Please try again at a later time.";
    }
}
export class AdvertiserUpdateFailedHost extends MadSDKAPIError {
    constructor(originalError) {
        super(originalError);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, AdvertiserUpdateFailedHost);
        }
        this.name = "AdvertiserUpdateFailedHost";
        this.message = "Failed to update advertiser. The Advertiser Domain is invalid.";
    }
}
export class AdvertiserUpdateFailedIdExists extends MadSDKAPIError {
    constructor(originalError) {
        super(originalError);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, AdvertiserUpdateFailedIdExists);
        }
        this.name = "AdvertiserUpdateFailedIdExists";
        this.message =
            "Failed to update advertiser. An advertiser with this External ID already exists.";
    }
}
export class AdvertiserDeleteFailed extends MadSDKAPIError {
    constructor(originalError) {
        super(originalError);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, AdvertiserDeleteFailed);
        }
        this.name = "AdvertiserDeleteFailed";
        this.message = "Failed to delete advertiser. Please try again at a later time.";
    }
}
export class AdvertiserIdCreationFailed extends MadSDKAPIError {
    constructor(originalError) {
        super(originalError);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, AdvertiserIdCreationFailed);
        }
        this.name = "AdvertiserIdCreationFailed";
        this.message = "Failed to create a ID for the new advertiser";
    }
}
export class AdvertiserInvalidAdomainSaveFailure extends MadSDKAPIError {
    constructor(adomain, originalError) {
        super(originalError);
        this.adomain = adomain;
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, AdvertiserInvalidAdomainSaveFailure);
        }
        this.name = "AdvertiserInvalidAdomainSaveFailure";
        this.message = `"${this.adomain}" is an invalid ad domain for an advertiser. Please try again.`;
    }
    static get apiErrorMessage() {
        return "invalid adomain";
    }
    static is(errors) {
        return errors.some((e) => e.includes(this.apiErrorMessage));
    }
}
//# sourceMappingURL=errors.js.map